import React from "react";
import { Modal } from 'rsuite'
import { MdDownload } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';
const ReportDownloadModal = (props) => {
  const {
    value,
    showReportDownloadModal,
    handleCloseModal,
    selectedOption,
    downloadListData,
    handleOpenVendor,
  } = props;
  return (
    <Modal
      backdrop={false}
      className="matched-child-list-modal"
      show={showReportDownloadModal}
      size="sm"
      onHide={handleCloseModal}
    >
      <Modal.Header>
        <Modal.Title className="text-black fw-bold fs-4 mb-0">
          {selectedOption?.label} Download
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ overflowY: "auto", maxHeight: "300px" }}>
        <div className="d-flex flex-column gap-2">
          {downloadListData.length === 0 && (
            <div className="text-center text-muted">
              No Downloading list found.
            </div>
          )}

          {downloadListData.map((data, index) => {
            return (
              <div
                key={index}
                className="card shadow-sm border-0 p-3"
                style={{
                  transition:
                    "transform 0.3s, box-shadow 0.3s, border 0.3s, background-color 0.3s",
                  cursor: "pointer",
                  maxWidth: "95%",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(0, 0, 0, 0.2)";
                  e.currentTarget.style.border = "2px solid #007bff";
                  e.currentTarget.style.backgroundColor = "#f0f8ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 10px rgba(0, 0, 0, 0.1)";
                  e.currentTarget.style.border = "2px solid transparent";
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
              >
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h5 className="rs-panel-title mb-0 fs-4 d-flex align-items-center">
                      {data?.suppliername || "No Supplier Name"}
                    </h5>
                    <h5 className="btn text-white bg-blue ms-3 mb-0 d-flex align-items-center">
                      {data?.listDataInfo?.count || "N/A"}
                    </h5>
                    {data?.isDownloaded && (
                      <FaCheck
                        style={{
                          color: "green",
                          fontSize: "1.8rem",
                          marginLeft: "8px",
                        }}
                      />
                    )}
                  </div>
                  <button
                    className="btn btn-success h4 mb-0 fw-bold rounded text-white d-flex align-items-center gap-2"
                    onClick={() =>
                      handleOpenVendor({
                        value,
                        offset: data?.listDataInfo?.offset,
                        limit: data?.listDataInfo?.limit,
                        index,
                      })
                    }
                  >
                    <MdDownload size={20} />
                    {data?.isDownloaded ? "Download Again" : "Download"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn width-100 h4 mb-0 fw-bold rounded text-white btn-secondary"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportDownloadModal;
